(() => {
  if (window.PioupiouFaqSearch) {
    window.PioupiouFaqSearch.initialize();
    return;
  }
  const normalize = (text) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase().replace(/[’']/g, ' ');
  const initialize = (root = document) => {
    root.querySelectorAll('[data-faq-searchable]').forEach((faq) => {
      if (faq.dataset.faqReady) return;
      faq.dataset.faqReady = 'true';
      const input = faq.querySelector('[data-faq-query]');
      const clear = faq.querySelector('[data-faq-clear]');
      const more = faq.querySelector('[data-faq-more]');
      const label = faq.querySelector('[data-faq-more-label]');
      const icon = faq.querySelector('[data-faq-more-icon]');
      const list = faq.querySelector('[data-faq-results]');
      const status = faq.querySelector('[data-faq-status]');
      const empty = faq.querySelector('[data-faq-empty]');
      const questions = [...faq.querySelectorAll('[data-faq-question]')];
      const texts = questions.map((question) => normalize(question.textContent));
      const spanish = faq.dataset.language === 'es';
      /* V10 : nombre de questions visibles d'emblée (data-initial), 0 par défaut */
      const initial = Math.min(parseInt(faq.dataset.initial || '0', 10) || 0, questions.length);
      let shown = initial;
      let previousQuery = '';
      const render = () => {
        const query = normalize(input.value.trim());
        const words = query.split(/\s+/).filter(Boolean);
        if (query !== previousQuery) questions.forEach((question) => { question.open = false; });
        if (!query && previousQuery) shown = initial;
        previousQuery = query;
        let count = 0;
        questions.forEach((question, index) => {
          const visible = query ? words.every((word) => texts[index].includes(word)) : index < shown;
          question.hidden = !visible;
          if (!visible) question.open = false;
          if (visible) count++;
        });
        list.hidden = count === 0;
        clear.hidden = input.value.length === 0;
        empty.hidden = !query || count > 0;
        status.hidden = !query || count === 0;
        status.textContent = query && count ? `${count} ${spanish ? (count === 1 ? 'respuesta encontrada' : 'respuestas encontradas') : (count === 1 ? 'réponse trouvée' : 'réponses trouvées')}` : '';
        more.hidden = Boolean(query) || questions.length <= initial;
        more.setAttribute('aria-expanded', String(!query && shown > initial));
        label.textContent = shown >= questions.length ? faq.dataset.lessLabel : faq.dataset.moreLabel;
        icon.textContent = shown >= questions.length ? '−' : '+';
      };
      input.addEventListener('input', render);
      input.addEventListener('search', render);
      clear.addEventListener('click', () => { input.value = ''; render(); input.focus(); });
      more.addEventListener('click', () => {
        const firstNew = shown;
        const collapse = shown >= questions.length;
        shown = collapse ? initial : Math.min(shown + 5, questions.length);
        render();
        if (collapse) {
          input.focus({ preventScroll: true });
          faq.scrollIntoView({ block: 'nearest' });
        } else questions[firstNew]?.querySelector('summary').focus({ preventScroll: true });
      });
      questions.forEach((question) => question.addEventListener('toggle', () => {
        if (question.open) questions.forEach((other) => { if (other !== question) other.open = false; });
      }));
      render();
    });
  };
  window.PioupiouFaqSearch = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
